<div class="news-box">
    <div class="news-text">
        <h2>Was gibts Neues?</h2>
        <p>Die neuesten Meldungen rund um Brother Produkte. Hier erfahren Sie mehr über aktuelle Aktionen, Lösungen und Programme für Ihre Kunden.</p>
        <a [routerLink]="['/news']" class="btn btn-primary small font-bold strict-sized-button mt-auto">News</a>
    </div>
    <div class="news-image"></div>
</div>
